import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';
import V10Reports_Template from "../V10Reports_Template";
import V11Reports_Template from "../v11Reports_Template";
import V11PublisherReports_Template from "../v11PublisherReports_Template";
import V10PublisherAdjReports_Template from "../v10PublisherAdjReports_Template.";
import TransactionServices from "../TransactionServices";
import YoutubeTemporaryBox from "./YoutubeTemporaryTable";
import ViewUploadFileLogBox from "./ViewUploadFileLog";


export default function Youtube(subEntity: any) {

    const [showtab, setShowTab] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("Youtube");
    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);


    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }


    /* const [displaytabs, setDisplayTabs] = useState(1);
    const currentPage = (e: React.SetStateAction<number>) => {
        setDisplayTabs(e);
        return 1;
    } */

    const tabs = [
        {
            id: 1, keys: "V1.0 Reports", title: "V1.0 Reports"
        },
        {

            id: 2, keys: "V1.1 Reports", title: "V1.1 Reports"
        },
        {
            id: 3, keys: "V1.1 PublisherReports", title: "V1.1 PublisherReports"
        },
        {
            id: 4, keys: "V1.0 PublisherAdjReports", title: "V1.0 PublisherAdjReports"
        },


    ]

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }


    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.youtubeV1Reports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.youtubeV1_1Reports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 3) {
            TransactionServices.youtubeV1PublisherReports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 4) {
            TransactionServices.youtubeV1PublisherAdjReports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }

    }

    let [checkNoDate, setCheckNoDate] = useState(false);
    let [checkRawReport, setCheckRawReport] = useState(false);
    let [checkReportData, setCheckReportData] = useState(false);
    let [checkReportNoDate, setCheckReportNoDate] = useState(false);
    let [getReportSuccess, setGetReportSuccess] = useState(false);
    let [deleteReportMsg, setDeleteReportMsg] = useState(false);

    let [youtubeTemporaryTableStatus, setYoutubeTemporaryTableStatus] = useState(false);
    const youtubeTemporaryTable = () => {
        setYoutubeTemporaryTableStatus(true)
    }
    let [openYoutubeTemporaryTable, setOpenYoutubeTemporaryTable] = useState(false);
        const YoutubeTemporaryTableClose = () => {
            youtubeTemporaryTableStatus = false
            setYoutubeTemporaryTableStatus(false)
        }

    let [fileUploadHistoryStatus, setFileUploadHistoryStatus] = useState(false);
    const viewUploadHistory = () => {
        fileUploadHistoryStatus = true;
        setFileUploadHistoryStatus(fileUploadHistoryStatus)
    }
    let [collapsedFileDetails, setcollapsedFileDetails] = useState(false);



    return (

        <div className="ws-12">

            <div className="box-content">

                <div className="ws-12">

                    <div className="ws-10">
                        <ul className="nav nav-tabs nav-justified">
                            <li data-ng-className="{active: isActiveTab('youtubeV10')}" data-ng-click="openTab('youtubeV10')" className="hide">
                                <a>V1.0 Reports</a>
                            </li>
                            <li data-ng-className="{active: isActiveTab('youtubeV11')}" data-ng-click="openTab('youtubeV11')" className="hide">
                                <a>V1.1 Reports</a>
                            </li>
                            <li data-ng-show="invoiceType != 'recording'" data-ng-className="{active: isActiveTab('youtubePubV11')}" data-ng-click="openTab('youtubePubV11')" className="hide">
                                <a>V1.1 Publisher Reports</a>
                            </li>
                            <li data-ng-show="invoiceType != 'recording'" data-ng-className="{active: isActiveTab('youtubePubAdj')}" data-ng-click="openTab('youtubePubAdj')" className="hide">
                                <a>V1.1 Publisher Adj Reports</a>
                            </li>
                            <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>V1.0 Reports</a>
                            <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>V1.1 Reports</a>
                            <a id="3" className={showtab === 3 ? "btn-success active" : "btn-success"} onClick={() => currentPage(3)}>V1.1 Publisher Reports</a>
                            <a id="4" className={showtab === 4 ? "btn-success active" : "btn-success"} onClick={() => currentPage(4)}>V1.1 Publisher Adj Reports</a>
                        </ul>
                    </div>

                    <div className="ws-2 pull-right">
                        <ul className="nav nav-tabs nav-justified pull-right">
                            <li data-ng-className="{active: isActiveTab('youtubeFiles')}" data-ng-click="openTab('youtubeFiles'); getYoutubeFiles()" className="pull-right" >
                                <a>YouTube Files</a>
                            </li>
                        </ul>

                    </div>
                </div>

                <div className="ws-12 box">
                    <div className="box-header well">
                        <h2 className="ws-6"><i className="icon-upload"></i> File Details</h2>

                        <div className="ws-6">
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedFileDetails(!collapsedFileDetails)}>
                                <i className={collapsedFileDetails ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            {collapsedFileDetails && <>
                                <button title="File Upload History" className="btn icon-btn info pull-right" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                                <button title="Check Temporary Table" className="btn icon-btn warning pull-right" onClick={() => youtubeTemporaryTable()}><i className="icon-doc-file"></i> </button>
                                <button title="Refresh File Details" className="btn icon-btn edit pull-right" data-ng-click="youtubeRefresh()">
                                    <i className="icon-refresh"></i>
                                </button>
                            </>}
                        </div>
                    </div>

                    {collapsedFileDetails && <>
                        <div className="box-content" >
                            {
                                checkNoDate && <div className="alert alert-info">Please select a month</div>
                            }
                            {
                                checkRawReport && <div className="alert alert-info">Data must be uploaded for both Raw and Report</div>
                            }
                            <div className="ws-12">
                                <div className="ws-6 ptl">
                                    <div className="ws-5">
                                        <label className="ws-4 text-right pts mtl  ">  Upload File</label>
                                        <div className="ws-8 mtl ">
                                            <label className="btn icon-btn edit btn-file btn-sm">Browse
                                                <input type="file" data-ng-model="file" className="pull-right hide" ng-model-rejected="rejFiles" />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ws-6 pt">
                                        <div className="progress">
                                            <div className="btn-lightBlue " role="progressbar">
                                                0%
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format ws-6">
                                    <label> Date </label>
                                    <div className="label-entries pull-left">
                                        <input type="text" placeholder="Select month and year" id="rawDataDate" name="rawDataDate" />

                                    </div>
                                </div>

                            </div>

                        </div>


                        <div className="box-footer" >
                            <button className="icon-btn warning pull-left btn-sm  ng-hide" data-ng-show="combineCount != 0" data-ng-click="youtubeClear()">
                                <i className="icon-close"></i> Clear Table
                            </button>
                            <button className="btn icon-btn edit btn-sm pull-left  ng-hide" data-ng-show="count != 0 &amp;&amp; !validate" data-ng-click="processData(rawDataDate)">
                                <i className="icon-calculator"></i> Process
                            </button>

                            <div className="ws-6 pull-right ng-hide" data-ng-show="combineCount != 0">
                                <div className="input-group">
                                    <span className="input-group-addon ">View Data For</span>
                                    <select className="form-control " ng-model="v10Reports" ng-change="youtubeSelect(v10Reports)">
                                        <option value="">Choose an account</option>
                                        <option value="v10ClaimSummary">Claim Summary Report</option>
                                        <option value="v10Video">Video Report</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </>}
                </div>

            </div >

            {
                (() => {
                    if (youtubeTemporaryTableStatus) {
                        return <YoutubeTemporaryBox param={youtubeTemporaryTableStatus} YoutubeTemporaryTableClose={YoutubeTemporaryTableClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (fileUploadHistoryStatus) {
                        return <ViewUploadFileLogBox param={fileUploadHistoryStatus} />
                    }
                })()
            }
        </div >
    );
}
